import { useEffect } from 'react';
import { Outlet, useRouter } from '@tanstack/react-router';
import { useNavTrail } from '@/lib/nav-context';

/**
 * Root route component. Auth/app layout split happens one level deeper so
 * unauthenticated pages (login/signup) don't render the AppShell.
 *
 * This is also the single writer of the journey trail: subscribing to the
 * router here means every completed navigation — sidebar, palette,
 * breadcrumbs, redirects, browser Back/Forward — is recorded uniformly,
 * and no individual link ever needs an onClick handler for it.
 */
export function RootShell(): JSX.Element {
  const router = useRouter();
  const record = useNavTrail((s) => s.record);

  useEffect(() => {
    // Seed with wherever the app booted (deep link, refresh).
    const loc = router.state.location;
    record(loc.pathname, loc.hash);
    return router.subscribe('onResolved', ({ toLocation }) => {
      record(toLocation.pathname, toLocation.hash);
    });
  }, [router, record]);

  return <Outlet />;
}
